/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/array/ArrayFindDuplicates.ts
 * @create:      2025-06-26 15:59:16.597
 * @modify:      2025-07-11 21:19:12.777
 * @version:     6.0.0
 * @times:       7
 * @lines:       59
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { ArrayDistinct } from "./ArrayDistinct";

/**
 * Finds duplicate elements in an array.
 *
 * @param array - The array to search for duplicate elements.
 * @param distinct - If `true`, returns only distinct duplicate values (default: `true`). If `false`, returns all duplicate occurrences.
 * @returns An array containing the duplicate elements found in the input array. If `distinct` is `true`, each duplicate appears only once.
 *
 * @example
 * ```typescript
 * ArrayFindDuplicates([1, 2, 2, 3, 3, 3]); // returns [2, 3]
 * ArrayFindDuplicates([1, 2, 2, 3, 3, 3], false); // returns [2, 2, 3, 3, 3]
 * ```
 * 
 * @since 4.5.1
 * @version 2025-06-26
 */
export function ArrayFindDuplicates<T>(array: T[], distinct = true) {
    const duplicates = array.filter((item, index) => array.indexOf(item) !== index || array.lastIndexOf(item) !== index);
    if (distinct) {
        return ArrayDistinct(duplicates);
    }

    return duplicates;
}
